import { render } from "./CurrencyUnit.vue?vue&type=template&id=1c008236"
import script from "./CurrencyUnit.vue?vue&type=script&lang=js"
export * from "./CurrencyUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CurrencyUnit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c008236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c008236', __exports__)) {
    api.reload('1c008236', __exports__)
  }
  
  module.hot.accept("./CurrencyUnit.vue?vue&type=template&id=1c008236", () => {
    api.rerender('1c008236', render)
  })

}


export default __exports__